import React, { createContext, useContext, useEffect, useReducer, useState } from 'react'
import { Fragment } from 'react';
import { AuthContext } from '../../../App/App';
import { ContentBodyContext } from '../MainContent';
import ChatBody from './ChatBody';
import ChatFooter from './ChatFooter';
import ChatHeader from './ChatHeader';
import FilterBody from './FilterBody';
import FilterHeader from './FilterHeader';
import ModalAttachment from './ModalAttachment';
import jwt from 'jwt-decode'
import swal from 'sweetalert'

export const HelpdeskContext = createContext();

function Helpdesk() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const { stateAuth, dispatchAuth } = useContext(AuthContext);

    const initialReducer = {
        filter: 'all',
        filterSub: null,
        endpoint: `/api/v1/helpdesk/helpdesk/chats/client/all`,
        trigger: { message: null },
        active: null,
        chats: [],
        chat: [],
        modalattach: { status: false },
    }
    const reducer = (state, action) => {
        switch (action.type) {
            case "FILTER":
                return {
                    ...state,
                    filter: action.filter,
                    filterSub: action.filterSub,
                    endpoint: action.endpoint
                }
            case "TRIGGER":
                return {
                    ...state,
                    trigger: action.trigger,
                }
            case "ACTIVE":
                return {
                    ...state,
                    active: action.active,
                }
            case "CHATS":
                return {
                    ...state,
                    chats: action.payload,
                }
            case "CHAT":
                return {
                    ...state,
                    chat: action.payload,
                }
            case "MODALATTACH":
                return {
                    ...state,
                    modalattach: action.modalattach
                }
        }
    }

    const [tempResult, settempResult] = useState(null)
    useEffect(() => {
        //recievenew message
        stateContentBody.socket.on(`helpdesk-chat-callback`, function (res) {
            //handle duplicate
            dispatchHelpdesk({
                type: 'TRIGGER',
                trigger: { message: 'helpdesk-chat-admin', data: 'success', action: { name: res.action, data: res.data } },
            })
        })

        //send cahat error
        stateContentBody.socket.on(`helpdesk-chat-error-${jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id}`, function (res) {
            dispatchHelpdesk({
                type: 'TRIGGER',
                trigger: { message: 'helpdesk-chat-admin', data: 'error', action: { name: res.action, data: null } },
            })
            if (res.message == `jwt expired`) {
                dispatchAuth({
                    type: "LOGOUT",
                    message: 'Token expired, please login again...'
                })
            } else {
                swal("Error!", `${res.message.replace('jwt', 'Token')}`, "error", {
                    button: "OK",
                });
            }
        })

        //send chat success
        stateContentBody.socket.on(`helpdesk-chat-success-${jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id}`, function (res) {
            //handle duplicate
            if (tempResult != res) {
                dispatchHelpdesk({
                    type: 'TRIGGER',
                    trigger: { message: 'helpdesk-chat-admin', data: 'success', action: { name: res.action, data: res.data } },
                })
                settempResult(res)
            }
        })

        //close chat success
        stateContentBody.socket.on(`helpdesk-user-feedback-close-success-${jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id}`, function (res) {
            //handle duplicate
            if (tempResult != res) {
                dispatchHelpdesk({
                    type: 'TRIGGER',
                    trigger: { message: 'helpdesk-user-feedback', data: 'success', action: { name: res.data.action, data: res.data } },
                })
                settempResult(res)
            }
        })

        //response close chat by user
        stateContentBody.socket.on(`helpdesk-user-feedback-close-callback`, function (res) {
            dispatchHelpdesk({
                type: 'TRIGGER',
                trigger: { message: 'helpdesk-user-feedback', data: 'success', action: { name: res.data.action, data: res.data } },
            })
        })

    }, [])

    const [stateHelpdesk, dispatchHelpdesk] = useReducer(reducer, initialReducer)
    return (
        <Fragment>
            <div className="section-body">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body p-0 mt-2 ml-0 mr-0">
                                <div className="section-title mt-0  ml-3 pb-1">
                                    {stateAuth.page}
                                </div>
                                <div className="tickets" >
                                    <div className="ticket-items p-0 m-1"  >
                                        <div className="card chat-box card-success mb-0 pb-0" id="mychatbox2" style={{ minHeight: '80vh' }}>
                                            <HelpdeskContext.Provider value={{ stateHelpdesk, dispatchHelpdesk }} >
                                                <FilterHeader />
                                                <FilterBody />
                                            </HelpdeskContext.Provider>
                                        </div>
                                    </div>
                                    <div className="ticket-content p-0 m-1">
                                        <div className="ticket-description">
                                            <div className="card chat-box card-success  mb-0 pb-0" id="mychatbox2" style={{ minHeight: '80vh' }}>
                                                <HelpdeskContext.Provider value={{ stateHelpdesk, dispatchHelpdesk }} >
                                                    <ChatHeader />
                                                    <ChatBody />
                                                    <ChatFooter />
                                                </HelpdeskContext.Provider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <HelpdeskContext.Provider value={{ stateHelpdesk, dispatchHelpdesk }} >
                <ModalAttachment />
            </HelpdeskContext.Provider>
        </Fragment>
    )
}

export default Helpdesk
